<template>
  <div>
    <TableManager
      ref="TableManager"
      v-if="state == 'User'"
      @filterChanged="filterChanged"
      @paginationChanged="paginationChanged"
      @customersChanged="customersChanged"
      :options="options"
      @ClickOnAddButton="showAddUser"
      @ClickOnSearchButton="refreshTable"
      @ClickOnClearButton="ClickOnClearButton"/>
    <Users
      ref="Users"
      v-if="state == 'User'"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      :curCustomers="curCustomers"
      @ClickOnPaymentButton="ClickOnPaymentButton"
      v-model="totalRows"
      @rowClickHandler="rowClickHandler"
      @makeToasts="makeToasts"/>
    <TableManagerBottom style="margin:5px"
      v-if="state == 'User'"
      :totalRows="totalRows"
      :perPage="perPage"
      v-model="currentPage"/>
    <b-modal ref="refUserAccounts" hide-footer :title="$t('Select user account')" @hidden="isShowAccounts = false">
      <Accounts v-if="isShowAccounts" :userId="user_id" @clickOnAccount="clickOnAccount" @makeToasts="makeToasts"></Accounts>
      <b-row>
        <b-col cols="9">
        </b-col>
        <b-col>
          <b-btn variant="secondary" @click="hideModal">{{ $t('Cancel') }}</b-btn>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal ref="AddUser" hide-footer @hidden="isShowAddUser = false" :title="$t('New customer')">
      <FormAddUser v-if="isShowAddUser" @refreshTable="refreshTable" @hideAddUser="hideAddUser" @makeToasts="makeToasts"></FormAddUser>
    </b-modal>
    <b-modal ref="refPayment" hide-footer @hidden="isShowPayment = false">
      <Payment :accountId="account_id" :userId="user_id" v-if="isShowPayment" @makeToasts="makeToasts" @refreshTable="refreshTable"  @close="closePayment()"></Payment>
    </b-modal>
    <FormClearCardUsers/>
  </div>
</template>

<script>
import Payment from '@/pages/users/formPayment'

import Accounts from '@/components/tables/users/Accounts.vue'
import Users from '@/components/tables/users/Users.vue'

import TableManager from '@/components/tables/TableManager'
import TableManagerBottom from '@/components/tables/TableManagerBottom'

import FormAddUser from './formAdd'
import FormClearCardUsers from './formClearCardUsers'
export default {
  components: {
    Payment,
    Accounts,
    Users,
    TableManager,
    TableManagerBottom,
    FormAddUser,
    FormClearCardUsers
  },
  data () {
    return {
      curCustomers: 0,
      isShowPayment: false,
      options: {
        isShowAddButton: true,
        isCustomers: true,
        isShowClearButton: false
      },
      isShowAccounts: false,
      isShowAddUser: false,
      user_id: null,
      account_id: null,
      filter: '',
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      state: 'User',
      currentRow: null
    }
  },
  methods: {
    ClickOnClearButton () {
      this.$root.$emit('bv::show::modal', 'modalFormClearCardUsers', '#btnShow')
    },
    makeToasts (variant, body, title) {
      this.$root.$emit('makeToasts', variant, body, title)
    },
    refreshTable (filter = '') {
      this.filter = String(filter).toLowerCase()
      this.currentPage = 1
      this.currentRow = null
      this.$refs.Users.load(this.filter)
      this.$refs.TableManager.filter = this.filter
      this.$refs.AddUser.hide()
    },
    filterChanged (value) {
      this.currentPage = 1
      this.filter = value
    },
    paginationChanged (value) {
      this.currentPage = 1
      this.perPage = value
    },
    customersChanged (value) {
      this.curCustomers = value
    },
    ClickOnPaymentButton (row) {
      this.user_id = row.user_id
      if (row.accounts.length === 1) {
        this.$refs.refUserAccounts.hide()
        this.account_id = row.accounts[0]
        this.isShowPayment = true
        this.$refs.refPayment.show()
        this.isShowAccounts = false
      } else {
        this.showModal()
      }
    },
    clickOnAccount (row) {
      this.$refs.refUserAccounts.hide()
      this.account_id = row.account_id
      this.isShowPayment = true
      this.$refs.refPayment.show()
      this.isShowAccounts = false
    },
    showModal () {
      this.isShowAccounts = true
      this.$refs.refUserAccounts.show()
    },
    hideModal () {
      this.isShowAccounts = false
      this.$refs.refUserAccounts.hide()
    },
    showAddUser () {
      this.isShowAddUser = true
      this.$refs.AddUser.show()
    },
    hideAddUser () {
      this.isShowAddUser = false
      this.$refs.AddUser.hide()
    },
    closePayment () {
      this.isShowPayment = false
      this.$refs.refPayment.hide()
    },
    rowClickHandler (row) {
      if (this.currentRow) {
        this.currentRow._rowVariant = ''
      }
      this.currentRow = row
      this.user_id = row.user_id
      this.$set(this.currentRow, '_rowVariant', 'info')
    }
  },
  watch: {
    curCustomers () {
      if (this.curCustomers) {
        this.options.isShowClearButton = true
      } else {
        this.options.isShowClearButton = false
      }
    }
  },
  mounted () {
    this.$store.dispatch('Users/GET_USERS_COUNT', 1).then(response => {
      let tmp = {
        isCard: 1,
        to: 0,
        from: 0
      }
      tmp.to = this.$store.getters['Users/USERS_COUNT'].count
      this.$store.dispatch('Users/GET_USERS_LIST', tmp)
    })
    this.$store.dispatch('Users/GET_CARD_POOLS')
    this.$store.dispatch('Users/USERS_SEARCH', {value: ''})
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/main.vue